import React from 'react'
import cn from 'classnames'

import { fileClass } from 'util/mime'
import { propFunc } from 'util/functions'

import Header from './Header'
import Attachment from './Attachment'
import styles from './styles.css'

const Attachments = props => {
  const { attachments } = props
  if (!attachments || attachments.length === 0) return <EmptyState {...props} />
  const fileAttachments = []
  const imageAttachments = []
  attachments.map(attachment => {
    if (fileClass(attachment.file_type) === 'image') {
      imageAttachments.push(attachment)
    } else {
      fileAttachments.push(attachment)
    }
  })

  return (
    <NormalState
      {...props}
      allAttachments={attachments}
      fileAttachments={fileAttachments}
      imageAttachments={imageAttachments}
    />
  )
}

Attachments.defaultProps = {
  forDraft: false,
}

const key = attachment => attachment.key || attachment.file_name

const NormalState = props => {
  const { allAttachments, deviceTypeIsDesktop, forNote, className } = props
  const isUploading = allAttachments.some(a => a.isUploading)
  return (
    <div
      className={cn(styles.Attachments, className, {
        [styles['Attachments-forNote']]: forNote,
      })}
    >
      <Header
        isDesktop={deviceTypeIsDesktop}
        attachments={allAttachments}
        isUploading={isUploading}
      />
      {deviceTypeIsDesktop ? (
        <DesktopAttachmentLists {...props} />
      ) : (
        <MobileAttachmentLists {...props} />
      )}
    </div>
  )
}

class DesktopAttachmentLists extends React.PureComponent {
  componentDidMount() {
    this.scrollContainer()
  }

  componentDidUpdate(prevProps) {
    if (this.props.allAttachments.length !== prevProps.allAttachments.length)
      this.scrollContainer()
  }

  saveRef = node => (this.container = node)

  scrollContainer = () => {
    if (this.container) {
      const parentScroller = this.container.parentNode.parentNode
      parentScroller.scrollTop = parentScroller.scrollHeight
    }
  }

  render() {
    const {
      allAttachments,
      fileAttachments,
      imageAttachments,
      forNote,
      onClickImage,
      forDraft,
    } = this.props

    return (
      <div ref={this.saveRef}>
        {imageAttachments.length > 0 && (
          <div className={styles['Attachments-grid']} key="images">
            {imageAttachments.map((attachment, index) => (
              <div
                className={styles['Attachments-gridCell']}
                key={key(attachment)}
              >
                <Attachment
                  attachment={attachment}
                  error={attachment.error}
                  forDraft={forDraft}
                  forNote={forNote}
                  isImage
                  isSingle={allAttachments.length === 1}
                  isUploading={attachment.isUploading}
                  key={key(attachment)}
                  onClick={propFunc(onClickImage, imageAttachments, index)}
                />
              </div>
            ))}
          </div>
        )}
        {fileAttachments.length > 0 && (
          <div className={styles['Attachments-list']} key="files">
            {fileAttachments.map(attachment => (
              <Attachment
                attachment={attachment}
                error={attachment.error}
                forDraft={forDraft}
                forNote={forNote}
                isSingle={allAttachments.length === 1}
                isUploading={attachment.isUploading}
                key={key(attachment)}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
}

const MobileAttachmentLists = ({
  allAttachments,
  uploadingAttachments,
  forNote,
  forDraft,
}) => {
  return (
    <div>
      {allAttachments.length > 0 && (
        <div className={styles['Attachments-list']} key="all">
          {allAttachments.map(attachment => (
            <Attachment
              key={attachment.key || attachment.file_name}
              attachment={attachment}
              isSingle={allAttachments.length === 1}
              isUploading={attachment.isUploading}
              forNote={forNote}
              forDraft={forDraft}
            />
          ))}
        </div>
      )}
    </div>
  )
}

const EmptyState = () => null

export default Attachments
